/* global axios */
import ApiClient from '../ApiClient';

class NexceoSiteVisitsAPI extends ApiClient {
  constructor() {
    super('nexceo/site_visits', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  confirm(id) {
    return axios.post(`${this.url}/${id}/confirm`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  cancel(id, reason = '') {
    return axios.post(`${this.url}/${id}/cancel`, { reason });
  }

  reschedule(
    id,
    { scheduledAt, endsAt = null, notes, location, assignedAgentId } = {}
  ) {
    const payload = { scheduled_at: scheduledAt, ends_at: endsAt };
    if (notes !== undefined) payload.notes = notes;
    if (location !== undefined) payload.location = location;
    if (assignedAgentId !== undefined)
      payload.assigned_agent_id = assignedAgentId;
    return axios.post(`${this.url}/${id}/reschedule`, payload);
  }

  resendConfirmation(id) {
    return axios.post(`${this.url}/${id}/resend_confirmation`);
  }

  retryMeetLink(id) {
    return axios.post(`${this.url}/${id}/retry_meet_link`);
  }

  updateMeetingLink(id, meetingLink) {
    return axios.patch(`${this.url}/${id}`, {
      site_visit: { meeting_link: meetingLink },
    });
  }
}

export default new NexceoSiteVisitsAPI();
